import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  CustomInput
} from "reactstrap";
import { USER_ROLES } from "../../utils/constant";
import "./UserModal.css";

export default class UserModal extends React.Component {
  render() {
    const closeBtn = (
      <button className="close" onClick={this.props.toggle}>
        <span aria-hidden={true}>×</span>
      </button>
    );
    return (
      <Modal
        isOpen={this.props.open}
        toggle={() => this.props.toggle(this.props.user)}
        centered={true}
        size="sm"
      >
        <ModalHeader
          toggle={() => this.props.toggle(this.props.user)}
          close={closeBtn}
        >
          選擇身份
        </ModalHeader>
        <ModalBody>
          <p className="text-warning text-center">{this.props.errorMsg}</p>

          <FormGroup>
            <div>
              {USER_ROLES.map((role, index) => (
                <CustomInput
                  key={`role-${index}`}
                  type="radio"
                  id={`exampleCustomRadio${index}`}
                  name="customRadio"
                  label={role.display_name}
                  className="mb-2"
                  checked={
                    this.props.user.role
                      ? this.props.user.role.id === role.id
                      : false
                  }
                  onChange={() => this.props.onRoleChange(role.id)}
                />
              ))}
            </div>
          </FormGroup>
          <div className="mt-4 d-flex justify-content-end">
            <Button
              color="secondary"
              type="button"
              onClick={() => this.props.toggle(this.props.user)}
            >
              取消
            </Button>
            <Button color="default" onClick={this.props.confirm}>
              確認
            </Button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
